import * as React from "react";
import { useCallback, useMemo } from "react";
import { Link, useLocation, useLinkClickHandler } from "react-router-dom";
const NAV_CHILDREN = ["Button", "NavItem"];
const _targetPathname = (target) => String(target).split(/[?#]/)[0];
const _setActiveClassName = (pathname, to, currentClassName, displayName, relativeActive) => {
  const targetPathname = _targetPathname(to);
  const isActive = relativeActive ? pathname.startsWith(targetPathname) : targetPathname === pathname;
  const isNavComponent = NAV_CHILDREN.includes(displayName);
  return isNavComponent && isActive ? `active ${currentClassName != null ? currentClassName : ""}` : currentClassName;
};
const isLeftClickEvent = (e) => (e == null ? void 0 : e.button) === 0;
const isModifiedEvent = (e) => !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
const LinkContainer = ({ children, onClick = void 0, to: toProp, relativeActive = false, ...rest }) => {
  const { pathname } = useLocation();
  const {
    props: { onClick: childrenOnClick, className, disabled },
    type: { displayName }
  } = React.Children.only(children);
  const to = typeof toProp === "object" && "pathname" in toProp ? toProp.pathname : toProp;
  const childrenClassName = useMemo(
    () => _setActiveClassName(pathname, to, className, displayName, relativeActive),
    [pathname, to, className, displayName, relativeActive]
  );
  const handleClick = useLinkClickHandler(to);
  const _onClick = useCallback(
    (e) => {
      if (!isLeftClickEvent(e) || isModifiedEvent(e) || disabled) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (childrenOnClick) {
        childrenOnClick();
      }
      if (onClick) {
        onClick();
      }
      if (!disabled) {
        handleClick(e);
      }
    },
    [disabled, childrenOnClick, onClick, handleClick]
  );
  return React.cloneElement(React.Children.only(children), {
    ...rest,
    className: childrenClassName,
    onClick: _onClick,
    disabled: !!disabled,
    href: disabled ? void 0 : to
  });
};
export { Link, LinkContainer };
